<template lang="pug">
.blue-shadow3
  img(src="~assets/card-shadow.png")
  
</template>
<script>
export default {
  name: 'BlueShadow3',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.blue-shadow3
  position: absolute
  width: 120%
  height: pxToRem(190)
  left: -10%
  bottom: -5%
  z-index: -1
  opacity: 1
  img
    width: 100%
</style>
